import { Box, Stack, Text } from "@mantine/core";
import {
  IconAt,
  IconBrandInstagram,
  IconBrandTelegram,
  IconBrandWhatsapp,
  IconPhone,
  IconSun,
} from "@tabler/icons-react";
import { ContactInformation, SocialLinks } from "../../../../Lib/Data";
import classes from "./get_in_touch-icons.module.css";

// ... (imports)

interface GetInTouchIconsProps
  extends Omit<React.ComponentPropsWithoutRef<"div">, "title"> {
  icon: typeof IconSun;
  title: React.ReactNode;
  description: React.ReactNode;
  link?: string;
  variant?: "white" | "default";
}

function GetInTouchIcons({
  icon: Icon,
  title,
  description,
  link,
  variant,
  ...others
}: GetInTouchIconsProps) {
  const textColor = variant === "white" ? "white" : undefined;

  return (
    <div className={classes.wrapper} {...others}>
      <Box mr="md">
        <Icon size={24} color={textColor} />
      </Box>

      <div>
        <Text
          size="xs"
          className={classes.title}
          c={textColor ? "white" : "dimmed"}
        >
          {title}
        </Text>
        <a target="_blank" href={link} style={{ textDecoration: "none" }}>
          <Text className={classes.description} c={textColor}>
            {description}
          </Text>
        </a>
      </div>
    </div>
  );
}

const InformationData = [
  {
    title: "Email",
    description: ContactInformation.email,
    icon: IconAt,
    link: `mailto:${ContactInformation.email}`,
  },
  {
    title: "Whatsapp",

    link: SocialLinks.whatsappLink,
    description: ContactInformation.phone,
    icon: IconBrandWhatsapp,
  },
  {
    title: "Instagram",

    description: ContactInformation.instagram,
    icon: IconBrandInstagram,
    link: `https://www.instagram.com/manysubsng?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==`,
  },
  {
    title: "Telegram",
    description: ContactInformation.telegram,
    icon: IconBrandTelegram,
    link: "https://t.me/manysubsng",
  },
];

export function GetInTouchIconsList({
  variant,
}: {
  variant?: "white" | "default";
}) {
  const items = InformationData.map((item, index) => (
    <GetInTouchIcons key={index} {...item} variant={variant} />
  ));
  return <Stack>{items}</Stack>;
}
